import { IonHeader, IonModal, IonToolbar } from "@ionic/react";
import "../theme/GlobalStyles.css";
import faqs from "../assets/json/FAQs.json";

function ModalRow({ question, answer }: { question: string; answer: string }) {
  return (
    <div>
      <p className="faqQuestion">{question}</p>
      <p className="faqAnswer">{answer}</p>
    </div>
  );
}

const FAQsModal = ({ isOpen, handleModalDismiss }: { isOpen: boolean; handleModalDismiss: () => void }) => {
  return (
    <IonModal backdropDismiss={true} onWillDismiss={() => handleModalDismiss()} isOpen={isOpen} className="reportModal">
      <IonHeader>
        <IonToolbar>
          <div id="toolbarContent">
            <div className="toolbarSides" />
            <p>FAQs</p>
            <div className="toolbarSides">
              <button type="button" className="closeBtn" onClick={() => handleModalDismiss()}>
                Close
              </button>
            </div>
          </div>
        </IonToolbar>
      </IonHeader>
      <div id="modalContentContainer">
        <div id="modalContainer" style={{ marginBottom: "16px" }}>
          <h2 className="faqHeader">The system</h2>
          {faqs.systemFAQs.map((faq, index) => (
            <ModalRow key={index} question={faq.question} answer={faq.answer} />
          ))}
          <h2 className="faqHeader">The reports</h2>
          {faqs.reportsFAQs.map((faq, index) => (
            <ModalRow key={index} question={faq.question} answer={faq.answer} />
          ))}
          <h2 className="faqHeader">Miscellaneous</h2>
          {faqs.miscellaneousFAQs.map((faq, index) => (
            <ModalRow key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </IonModal>
  );
};

export default FAQsModal;
